/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export const MethodColumnFormatter = (cellContent, row, rowIndex) => {
  const { method } = row;
  return (
    <>
      <div className="d-flex align-items-center text-capitalize">
        {method ? method : "-"}
      </div>
      <> </>
    </>
  );
};
